/**
 * Change Password API — Layer 1 of the three-layer pattern.
 *
 * Pure async function, no TanStack, no React imports.
 */
import { apiClient } from "@/shared/lib/axios";
import { AUTH } from "@/shared/lib/apiPaths";

export async function changePassword(
  oldPassword: string,
  newPassword: string,
  newPasswordConfirm: string
): Promise<void> {
  await apiClient.post(`${AUTH}/change-password`, {
    oldPassword,
    newPassword,
    newPasswordConfirm,
  });
}